(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-registration-form]');
    const submit = root.querySelector('[data-registration-submit]');
    const error = root.querySelector('[data-registration-error]');
    const success = root.querySelector('[data-registration-success]');
    let requestId = crypto.randomUUID();
    const today = new Date();
    form.elements.purchase_date.max = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
    submit.disabled = !root.dataset.endpoint;
    if (!root.dataset.endpoint) { error.textContent = 'Registration is temporarily unavailable. Please contact our support team.'; error.hidden = false; }
    const label = submit.innerHTML;
    let pending = false;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (pending || !form.reportValidity()) return;
      pending = true; submit.disabled = true; submit.textContent = 'Saving your registration…'; error.hidden = true;
      const payload = Object.fromEntries(new FormData(form));
      payload.marketing_consent = form.elements.marketing_consent.checked;
      payload.request_id = requestId;
      try {
        const response = await fetch(root.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:AbortSignal.timeout(45000)});
        const result = await response.json().catch(() => { throw new Error('Registration is temporarily unavailable. Your details are still here; please try again.'); });
        if (!response.ok || result.ok !== true || result.reference !== requestId) throw new Error(result.error || 'We could not confirm your registration. Please try again.');
        root.querySelector('[data-registration-reference]').textContent = result.reference;
        root.querySelector('[data-registration-preference]').textContent = payload.marketing_consent ? 'Your preference to receive product updates has been saved.' : 'Your registration is complete. You have not opted in to promotional emails.';
        form.hidden = true; success.hidden = false; success.focus();
      } catch (failure) {
        error.textContent = failure.name === 'TimeoutError' || failure instanceof TypeError ? 'We could not confirm your registration. Check your connection and try again; your details are still here.' : failure.message;
        error.hidden = false; error.focus();
      } finally { pending = false; submit.disabled = false; submit.innerHTML = label; }
    });
    root.querySelector('[data-registration-another]').addEventListener('click',() => {
      form.reset(); requestId = crypto.randomUUID(); success.hidden = true; form.hidden = false; form.elements.first_name.focus();
    });
  }
  document.querySelectorAll('[data-registration]').forEach(initialize);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-registration]').forEach(initialize));
})();
